export default class CmsApi {

	/**
	 * @param {string} propertySlug
	 * @return {Promise<any>}
	 */
	static fetchProperty(propertySlug) {
		return fetch(`/api/properties/${propertySlug}/`).then(rs => rs.json());
	}

	/**
	 * @param {string} propertySlug
	 * @return {Promise<any>}
	 */
	static fetchPropertyPlaces(propertySlug) {
		return fetch(`/api/properties/${propertySlug}/places/`).then(rs => rs.json());
	}

}
